import * as React from 'react';
import {
    type NavigateOptions,
    type To,
    useLocation,
    useNavigate
} from 'react-router';

type NavigateWithQuery = (path: string, options?: NavigateOptions) => void;

export const useNavigateWithQuery = (): NavigateWithQuery => {
    const navigate = useNavigate();
    const location = useLocation();

    return React.useCallback(
        (path: string, options?: NavigateOptions) => {
            const newPath: To = {
                pathname: path,
                search: location.search
            };
            void navigate(newPath, options);
        },
        [navigate, location.search]
    );
};
